<template>
  <div>
    <p class="text-bold mb-2 mt-4">
      <img v-bind:src="'/images/master-dashboard/' + type + '_unlocked.svg'" class="icon mr-1" />
      {{ title }}
    </p>
    <div v-if="isLoading">
      <b-skeleton height="8px" />
      <b-skeleton height="14px" />
    </div>
    <div v-else>
      <b-progress :value="(completed / total) * 100" class="mb-2" variant="secondary" />

      <small class="d-flex">
        {{ infoText }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChaptersProgress",
  props: {
    title: String,
    completed: Number,
    total: Number,
    type: String,
    infoText: String,
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.icon {
  width: 23px;
  height: 23px;
}
.progress {
  height: 8px;
  background: $color-dark-200;
}
</style>
